import {
  CheckCircleIcon,
  GraduationCapIcon,
  SmileyXEyesIcon,
  TimerIcon,
  UserCircleIcon,
  UsersIcon,
  UsersThreeIcon,
  XCircleIcon,
} from '@phosphor-icons/react';
import { useEffect, useState } from 'react';

const ATTEMPT_TYPES = [
  { label: 'Perfect', icon: <CheckCircleIcon size={20} />, color: 'var(--q3-green-normal)' },
  { label: 'Wasted', icon: <XCircleIcon size={20} />, color: 'var(--q3-danger-normal)' },
  { label: 'Overtime', icon: <TimerIcon size={20} />, color: 'var(--q3-orange-normal)' },
  { label: 'Confused', icon: <SmileyXEyesIcon size={20} />, color: 'var(--q3-neutral-light)' },
];

export default function ComparativeAttemptAnalysisTable({
  selectedSubject,
  comparativeAttemptAnalysis,
  userAttemptAnalysis,
}) {
  const [subjectUserAttemptAnalysis, setSubjectUserAttemptAnalysis] = useState(null);
  const [subjectComparativeAttemptAnalysis, setSubjectComparativeAttemptAnalysis] = useState(null);

  useEffect(() => {
    if (!selectedSubject) return;
    const subjectId = selectedSubject?.id?.toString();

    setSubjectUserAttemptAnalysis(userAttemptAnalysis?.filter((item) => item?.subject_id?.toString() === subjectId));
    setSubjectComparativeAttemptAnalysis(
      comparativeAttemptAnalysis?.filter((item) => item?.subject_id?.toString() === subjectId),
    );
  }, [selectedSubject]);

  if (!selectedSubject || !subjectUserAttemptAnalysis || !subjectComparativeAttemptAnalysis) return null;

  const getComparativeValue = (type, key) =>
    subjectComparativeAttemptAnalysis?.[0]?.values?.find((item) => item.title === type)?.values?.[key];

  const renderCell = (value) => (
    <td className="border-r border-[var(--q3-stroke-light)] text-center">
      {value !== undefined && value !== null ? (
        value
      ) : (
        <span className="text-xs text-[var(--q3-neutral-default)]">—</span>
      )}
    </td>
  );

  const renderRow = (icon, label, dataSourceFn) => (
    <tr className="border-b border-[var(--q3-stroke-light)] hover:bg-[var(--q3-surface-dim)]">
      <td className="h-16 w-75 border-r border-[var(--q3-stroke-light)]">
        <div className="flex items-center px-4 gap-4">
          {icon}
          <p className="truncate text-base font-semibold text-[var(--q3-neutral-default)]">{label}</p>
        </div>
      </td>
      {ATTEMPT_TYPES.map((type) => renderCell(dataSourceFn(type.label)))}
    </tr>
  );

  return (
    <div className="overflow-x-auto rounded-b-xl border border-t-0 border-[var(--q3-stroke-light)]">
      <table className="text-sm w-full">
        <thead className="bg-[var(--q3-surface-dim)]">
          <tr className="h-16">
            <td className="py-3 px-4 w-75 text-start border-r border-[var(--q3-stroke-light)]">
              <div className="line-clamp-2 max-w-75 leading-snug">Students</div>
            </td>
            {ATTEMPT_TYPES.map((type, idx) => (
              <td
                key={idx}
                className="py-3 px-4 min-w-[135px] text-center border-r last:border-r-0 border-[var(--q3-stroke-light)]"
              >
                <div
                  className="line-clamp-2 max-w-[135px] mx-auto leading-snug flex flex-row gap-2 items-center justify-center"
                  style={{ color: type.color }}
                >
                  {type.icon}
                  <p>{type.label}</p>
                </div>
              </td>
            ))}
          </tr>
        </thead>
        <tbody>
          {renderRow(
            <UserCircleIcon size={24} className="text-[var(--q3-neutral-default)]" />,
            'You',
            (type) => subjectUserAttemptAnalysis?.[0]?.[`${type.toLowerCase()}_attempts`],
          )}

          {/* {renderRow(<GraduationCapIcon size={24} className="text-[var(--q3-neutral-default)]" />, 'Topper', (type) =>
            getComparativeValue(type, 'topper'),
          )} */}

          {renderRow(<UsersIcon size={24} className="text-[var(--q3-neutral-default)]" />, 'Top 10%ile', (type) =>
            getComparativeValue(type, 'top_10_percent'),
          )}

          {renderRow(<UsersThreeIcon size={24} className="text-[var(--q3-neutral-default)]" />, 'Top 25%ile', (type) =>
            getComparativeValue(type, 'top_25_percent'),
          )}
        </tbody>
      </table>
    </div>
  );
}
